import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { User } from 'src/types/shared/User';

export const fetchProfileRequest = createAction('fetchProfileRequest');
export const fetchProfileSuccess = createAction<User>('fetchProfileSuccess');
export const fetchProfileFailure = createAction('fetchProfileFailure');

export const fetchProfile =
    () =>
    async (dispatch: AppDispatch): Promise<void> => {
        dispatch(fetchProfileRequest());
        try {
            const { data } = await api.get<User>(`admin/profile`);

            dispatch(fetchProfileSuccess(data));
        } catch (e) {
            handleApiErrors(dispatch, fetchProfileFailure, e);
        }
    };
